import { ReactComponent as Inbox } from '../assets/svgs/inbox.svg'

export const sendEmailProps = {
	Icon: Inbox,
	backgroundTransparent: true,
	header: 'checkEmail',
	subtext: 'verificationLinkSignup'
}
